import React from "react";
import type { AnySchema } from "yup";

interface ValidationContext {
  validationSchema: AnySchema;

  // For schemas with lazy fields, we can "resolve" the schemas at that field,
  // and created a nested ValidationContext, noting the field we resolved at
  // Used by `useFieldSchema`
  resolvedAt?: string;

  // For schemas with many nested fields, they can be resolved and passed in here
  // This will be returned when using `useFieldSchema`
  resolvedFields?: Record<string, AnySchema>;
}

export default React.createContext<ValidationContext | null>(null);
